import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import ApiKeyField from '../fields/api-key-field/api-key-field';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';
import ApiSecretField from '../fields/api-secret-field/api-secret-field';
import ReboundCredentialsStore from '../../../../stores/credentials/shipping/rebound-credentials-store';

interface IProps {
    credentialsStore: ReboundCredentialsStore,
    vGroup: IValidationGroup,
}

const ReboundCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <FormFieldLine
                required
                label='Rebound orders service Username'
                key='username'
                note='Enter the Rebound order service username'
            >
                <Input
                    value={credentialsStore.username}
                    onChange={credentialsStore.setUsername}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Rebound orders service Client'
                key='email_address'
                note='Enter the Rebound order service client'
            >
                <Input
                    value={credentialsStore.emailAddress}
                    onChange={credentialsStore.setEmailAddress}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Rebound orders service Frontend reference'
                key='frontend'
                note='Enter the Rebound order service frontend reference'
            >
                <Input
                    value={credentialsStore.frontend}
                    onChange={credentialsStore.setFrontend}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Rebound orders service Item Type'
                key='order-channel-id'
                note='Enter the Rebound order service item type'
            >
                <Input
                    value={credentialsStore.orderChannelId}
                    onChange={credentialsStore.setOrderChannelId}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Rebound orders service Parcel Type'
                key='parcel_type'
                note='Enter the Rebound order service parcel type'
            >
                <Input
                    value={credentialsStore.parcelType}
                    onChange={credentialsStore.setParcelType}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <ApiKeyField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='Rebound orders service Password'
                note='Enter the Rebound order service password'
            />
            <FormFieldLine
                required
                label='Rebound headless API Client ID'
                key='warehouse'
                note='Enter the Rebound headless API client ID'
            >
                <Input
                    value={credentialsStore.warehouse}
                    onChange={credentialsStore.setWarehouse}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <ApiSecretField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='Rebound headless API client secret'
                note='Enter the Rebound headless API client secret'
            />
        </>
    );
});

export default ReboundCredentials;
